import useDownloadReport from "@saleor/hooks/useDownloadReport";
import _ from "lodash";
import moment from "moment";

import { filterPayablesReportData, filterReportData } from "../batch/utils";
import { getYear } from "../batch/utils/handlers";
import { getCurrentTimestamp } from "./misc";

export const bulkBatchDownload = (arr, groupBy, fields, onSuccess) => {
  // multiple file download

  const groupedArr = Object.keys(_.groupBy(arr, groupBy));

  for (let i = 0; i <= groupedArr.length; i++) {
    const val = filterReportData(
      _.groupBy(arr, groupBy)[Object.keys(_.groupBy(arr, groupBy))[i]],
      // reportsDownload.activeBatchPayouts.fields
      fields
    ).map(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (
          typeof value === "string" &&
          value?.includes(",") &&
          !value?.match(/^".*?"$/)
        ) {
          item[key] = `"${value}"`;
        }
      });
      return item;
    });

    const fileNameBatchId = Object.values(
      _.groupBy(arr, "id")[groupedArr[i]]
    )[0].id;
    const fileNameMallCode = Object.values(
      _.groupBy(arr, "id")[groupedArr[i]]
    )[0].mall_code;
    const fileNameYear = getYear(
      Object.values(_.groupBy(arr, "id")[groupedArr[i]])[0].created
    );

    useDownloadReport(
      val,
      //   reportsDownload?.activeBatchPayouts?.fields,
      fields,
      `${fileNameMallCode}_${fileNameYear}_${atob(fileNameBatchId)}`,
      `${fileNameMallCode}_${fileNameYear}_${atob(
        fileNameBatchId
      )}-${getCurrentTimestamp()}`,
      "csv"
    );

    // checks if for loop iteration is done
    // ensures to call notify only once
    if (i + 1 >= Object.keys(_.groupBy(arr, "id")).length) {
      onSuccess();
    }
  }
};

export const bulkPayablesListDownload = (arr, groupBy, fields, onSuccess) => {
  // multiple file download

  const groupedArr = Object.keys(_.groupBy(arr, groupBy));

  for (let i = 0; i <= groupedArr.length; i++) {
    const val = filterPayablesReportData(
      _.groupBy(arr, groupBy)[Object.keys(_.groupBy(arr, groupBy))[i]],
      // reportsDownload.activeBatchPayouts.fields
      fields
    ).map(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (
          typeof value === "string" &&
          value?.includes(",") &&
          !value?.match(/^".*?"$/)
        ) {
          item[key] = `"${value}"`;
        }
      });
      return item;
    });

    const fileNameBatchId = Object.values(
      _.groupBy(arr, "batch_id")[groupedArr[i]]
    )[0].id;
    const fileNameMallCode = Object.values(
      _.groupBy(arr, "batch_id")[groupedArr[i]]
    )[0].mall_code;
    const fileNameYear = getYear(
      Object.values(_.groupBy(arr, "batch_id")[groupedArr[i]])[0].date_generated
    );
    const settllementDate = moment(
      Object.values(_.groupBy(arr, "batch_id")[groupedArr[i]])[0]
        .settlement_date
    ).format("YYYYMMDDHHmmss");

    useDownloadReport(
      val,
      //   reportsDownload?.activeBatchPayouts?.fields,
      fields,
      `${fileNameMallCode}_${fileNameYear}_${atob(fileNameBatchId)}`,
      `GeneratePayablesList_${fileNameMallCode}_${settllementDate}`,
      "csv"
    );

    // checks if for loop iteration is done
    // ensures to call notify only once
    if (i + 1 >= Object.keys(_.groupBy(arr, "batch_id")).length) {
      onSuccess();
    }
  }
};
